import React, { useState, useEffect } from 'react'
import './basic-information.less'
import { setHeader } from '@/util/set-header'
import compress from '@/util/image-compress'
import {
  getUserInfoApi,
  uploadPictureApi,
  updateUserInfoApi,
} from '@/api/user-infomation'
import { InputItem, Toast, Button } from 'antd-mobile'
import { getAuth } from '@/util/storage'
const auth = getAuth()
function BasicInformation() {
  const [name, setName]: any = useState()
  const [url, setUrl] = useState('/public/assets/img/avatar.png')
  useEffect(() => {
    const leftClick = () => {
      if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
    }
    setHeader({ title: '基本信息', leftClick })
    const fetchData = async () => {
      Toast.loading('加载中', 0)
      const { data } = await getUserInfoApi()
      Toast.hide()
      if (data.code !== 'SUCCESS') {
        return false
      }
      let { nickname, user_face } = data.data.info
      setName(nickname)
      setUrl(user_face)
    }
    fetchData()
  }, [])
  const handleChangeName = (event: string) => {
    var re = new RegExp(/[^a-zA-Z0-9\u4E00-\u9FA5]/g)
    if (re.test(event)) {
      Toast.info('不能输入特殊字符', 1.5)
      return false
    }
    setName(event)
  }

  const compressCallBack = async (resizeFile: any) => {
    let size = Math.round((resizeFile.size * 100) / (1024 * 1024)) / 100 //按MB换算
    //限制大小小于2M
    if (size < 2) {
      let formData = new FormData()
      formData.append('file_data', resizeFile)
      formData.append('type', 'user')
      Toast.loading('加载中', 0)
      const { data } = await uploadPictureApi(formData)
      Toast.hide()
      if (data.code !== 'SUCCESS') {
        Toast.info(data.msg, 2)
        return
      }
      setUrl(data.data.url)
    } else {
      Toast.info('文件大小超过系统规定大小', 3)
    }
  }

  //选择图片
  const selectedFile = (event: any) => {
    let file = event.target.files[0]
    event.target.value = ''
    //图片压缩
    compress(
      file,
      {
        compress: {
          width: 1600,
          height: 1600,
          quality: 0.5,
        },
        type: 'file',
      },
      (resizeFile: any) => {
        compressCallBack(resizeFile)
      },
    )
  }
  const updateInfo = async () => {
    if (name.length > 8) {
      Toast.info('昵称不能超过8个字符哦~', 2)
      return
    }
    if (name.length <= 0) {
      Toast.info('昵称不能为空哦~', 2)
      return
    }
    let formData = new FormData()
    formData.append('nickname', name)
    formData.append('user_face', url)
    formData.append('auth', auth)
    Toast.loading('加载中', 0)
    const { data } = await updateUserInfoApi(formData)
    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 2)
      return
    }
    if (window.WebViewBridge) {
      window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
    } else if (window.webkit) {
      window.webkit.messageHandlers.navBackMarket.postMessage('')
    }
  }
  return (
    <div>
      <div className="basic-info">
        <div className="avatar-upload">
          <input
            onChange={(event) => {
              selectedFile(event)
            }}
            type="file"
          />
          <img src={url} alt="avatar.png" />
        </div>
        <div>
          <InputItem
            className="nick-name font-8"
            placeholder="请输入昵称"
            value={name}
            onChange={handleChangeName}
            maxLength={8}
          >
            昵&nbsp;&nbsp;&nbsp;&nbsp;称
          </InputItem>
        </div>
        <Button className="save" type="primary" onClick={updateInfo}>
          <span className="font-5">保存修改</span>
        </Button>
      </div>
    </div>
  )
}

export default BasicInformation
